import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  behaviorTitle = new BehaviorSubject('');
  behaviorSubTitle = new BehaviorSubject('');
  behaviorDatePicker = new BehaviorSubject(false);

  title = this.behaviorTitle.asObservable();
  subTitle = this.behaviorSubTitle.asObservable();
  datePicker = this.behaviorDatePicker.asObservable();

  constructor() { }

  changeTitle(value) {
    this.behaviorTitle.next(value);
  }

  changeSubtitle(value) {
    this.behaviorSubTitle.next(value);
  }

  changeDatePicker(value) {
    this.behaviorDatePicker.next(value);
  }
}
